import hotkey from "./utils-js/hotKey"
import { es, runtime } from './utils-js'
import api from "../api";
import hkCombos from './hotKeyCombos'
import hkGroups from './hotKeyGroups'

// TODO: 实现用户登陆之后将 nobody 替换为用户 ID
let basePath = "/user/nobody/conf"
let fileName = `hotkey-${runtime.os}.conf`
let fullPath = `${basePath}/${fileName}`

let GlobalHotKey = new hotkey.HotKeyDefinition([], "Global HotKeys")

function reload(errCb, successCb) {
    api.hifs.getFile(fullPath, (error, data, response) => {
        if (error && response.statusCode !== 404) {
            console.log("hotkey reload failed:", error, ", response:", response, ", data:", data)
            if (errCb) errCb(error, data, response)
            return
        }

        let combosMap = undefined
        if (response.statusCode === 404) {
            // GlobalHotKey = new hotkey.HotKeyDefinition(DefaultHotKeyGroups, "Default HotKeys")
            combosMap = hkCombos.getCombosMap()
            console.log("There is no user hotkey definition in server, using default")
        } else {
            // console.log("hotkey reload data:", data)
            let pData = JSON.parse(data)
            // console.log("hotkey reload pData:", pData)
            combosMap = es.jsonParseMap(pData)
            // console.log("hotkey reload combosMap:", combosMap)
            // console.log("hotkey reload typeof combosMap:", typeof combosMap)
            // console.log("configuration init load from server data:", data)
        }

        // console.log("combosMap:", combosMap)
        hkGroups.getHotKeyGroups(combosMap).forEach((group) => {
            // console.log("Adding hotkey group:", group)
            GlobalHotKey.addGroup(group)
        })
        // console.log("GlobalHotKey:", GlobalHotKey)
        if (successCb) successCb(error, data, response)
    })
}

reload()

function save(errCb, successCb) {
    let combos = GlobalHotKey.exportCombos()
    // console.log("save: typeof combos:", typeof combos)
    // console.log("save: combos:", combos)
    let data = es.jsonStringifyMap(combos)

    // console.log("save: data:", data)
    // let loadCombos = es.jsonParseMap(data)
    // console.log("save: loadCombos:", loadCombos)
    // console.log("save: typeof loadCombos:", typeof loadCombos)

    let blob = new Blob([JSON.stringify(data)])
    api.hifs.postFile(fullPath, blob, (error, d, response) => {
        if (error) {
            console.log("save: post file failed: error:", error, ", response:", response)
            if (errCb) errCb(error, d, response)
            return
        }

        console.log("save: success!")
        if (successCb) successCb(error, d, response)
    })
}

function reset(cb) {
    GlobalHotKey.reset()
    api.hifs.deleteFile(fullPath, cb)
    hkGroups.getHotKeyGroups().forEach((group) => {
        console.log("Adding hotkey group:", group)
        GlobalHotKey.addGroup(group)
    })
}

function updateComboAndSave(keyName, oldCombo, newCombo, errCb, successCb) {
    let result = GlobalHotKey.updateCombo(keyName, oldCombo, newCombo)
    let err = `${keyName} not found in GlobalHotKey`
    if (result === null) errCb(err, "", {statusCode: 404, text: err})
    save(errCb, successCb)
}
function deleteComboAndSave(keyName, combo, errCb, successCb) {
    let result = GlobalHotKey.delCombo(keyName, combo)
    let err = `${keyName} not found in GlobalHotKey`
    if (result === null) errCb(err, "", {statusCode: 404, text: err})
    save(errCb, successCb)
}
function addComboAndSave(keyName, combo, errCb, successCb) {
    let result = GlobalHotKey.addCombo(keyName, combo)
    let err = `${keyName} not found in GlobalHotKey`
    if (result === null) errCb(err, "", {statusCode: 404, text: err})
    save(errCb, successCb)
}

function getTextByName(keyName) {
    // if (!GlobalHotKey) return
    let texts = GlobalHotKey.getTextsByName(keyName)
    // console.log("getTextByName: ", keyName, ", texts:", texts)
    if (texts !== null) {
        return texts[0]
    }

    return null
}
export default {
    basePath,
    fileName,
    fullPath,

    reset,
    reload,
    addComboAndSave,
    updateComboAndSave,
    deleteComboAndSave,
    GlobalHotKey,

    getTextByName,
    HotKey: hotkey.HotKey,
    HotKeyGroup: hotkey.HotKeyGroup,
    HotKeyDefinition: hotkey.HotKeyDefinition,
    texts2keys: hotkey.texts2keys,
    macAltMap: hotkey.macAltMap,
    macShiftAltMap: hotkey.macShiftAltMap,
}
